export default __webpack_public_path__ + "static/enhancing-healthcare-7b9dbd9404312384793fb3b0b20bad78.png";